import { createMultiTenantApi } from '@/utils'
import { config } from '../config'

export const api = createMultiTenantApi(config.backend)
